export { areEquivalent, toArray };

const areEquivalent = <T>(arrayA: readonly T[], arrayB: readonly T[]): boolean => {
	if (arrayA.length !== arrayB.length) {
		return false;
	}

	const occurrencesByItemInArrayA = new Map<T, number>();
	for (const item of arrayA) {
		const occurrences = occurrencesByItemInArrayA.get(item) ?? 0;
		occurrencesByItemInArrayA.set(item, occurrences + 1);
	}

	const occurrencesByItemInArrayB = new Map<T, number>();
	for (const item of arrayB) {
		const occurrences = occurrencesByItemInArrayB.get(item) ?? 0;
		occurrencesByItemInArrayB.set(item, occurrences + 1);
	}

	for (const [item, occurrencesInA] of occurrencesByItemInArrayA) {
		const occurrencesInB = occurrencesByItemInArrayB.get(item) ?? 0;
		if (occurrencesInA !== occurrencesInB) {
			return false;
		}
	}

	return true;
};

const toArray = <T>(value?: T | T[]): T[] => {
	if (value === undefined) {
		return [];
	}

	return Array.isArray(value) ? value : [value];
};
